import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-261c5618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offcanvas-header border-bottom py-0" }
const _hoisted_2 = { class: "left d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "offcanvas-title me-5" }, "PHARMA-PIM", -1))
const _hoisted_4 = { class: "right d-flex justify-content-end align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "refresh", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "offcanvas-body" }
const _hoisted_9 = {
  key: 0,
  class: "product row gx-3"
}
const _hoisted_10 = { class: "right col-10 col-xl-9" }
const _hoisted_11 = { class: "title mb-4 d-flex justify-content-begin align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "name fs-3 cu-p me-4 mb-0" }, "Productinformatie", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "general-feedback mb-4"
}
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-5 mb-0" }, "Gestructureerde eigenschappen", -1))
const _hoisted_19 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Cnk", -1))
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  key: 0,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Commerciële naam", -1))
const _hoisted_24 = { class: "col" }
const _hoisted_25 = {
  key: 1,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Merk", -1))
const _hoisted_27 = { class: "col" }
const _hoisted_28 = {
  key: 2,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Doelgroep", -1))
const _hoisted_30 = { class: "col" }
const _hoisted_31 = {
  key: 3,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Eenheid", -1))
const _hoisted_33 = { class: "col" }
const _hoisted_34 = {
  key: 4,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Vorm", -1))
const _hoisted_36 = { class: "col" }
const _hoisted_37 = {
  key: 5,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Breedte", -1))
const _hoisted_39 = { class: "col" }
const _hoisted_40 = {
  key: 6,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Hoogte", -1))
const _hoisted_42 = { class: "col" }
const _hoisted_43 = {
  key: 7,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Diepte", -1))
const _hoisted_45 = { class: "col" }
const _hoisted_46 = {
  key: 8,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Gewicht", -1))
const _hoisted_48 = { class: "col" }
const _hoisted_49 = {
  key: 9,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col item-title" }, "Volume", -1))
const _hoisted_51 = { class: "col" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_53 = {
  key: 2,
  class: "row"
}
const _hoisted_54 = { class: "col" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-5 mb-0" }, "Gestructureerde tekst fragmenten", -1))
const _hoisted_56 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_57 = { class: "desciption item-title" }
const _hoisted_58 = { class: "buttons d-flex justify-content-begin align-items-center" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = {
  key: 3,
  class: "row"
}
const _hoisted_64 = { class: "col" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-5 mb-0" }, "Vrije tekst fragmenten", -1))
const _hoisted_66 = { class: "desciption item-title" }
const _hoisted_67 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_PimFeedbackPanelOld = _resolveComponent("PimFeedbackPanelOld")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_MultilingualSwitcher, {
          "active-language": _ctx.activeLanguage,
          languages: _ctx.languages,
          onUpdateActiveLanguage: _cache[0] || (_cache[0] = (newValue) => _ctx.activeLanguage = newValue),
          "force-multilingual-support": true,
          errors: {},
          mb: 0
        }, null, 8, ["active-language", "languages"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-hover",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args)), ["prevent"]))
        }, _hoisted_6),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_AlertError2, {
        error: _ctx.productUI.getError(),
        class: "mb-3"
      }, null, 8, ["error"]),
      _createVNode(_component_BaseSpinner, {
        spin: _ctx.productUI.isNotReady()
      }, null, 8, ["spin"]),
      (_ctx.productUI.isReady())
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("button", {
                  class: "btn btn-sm btn-icon btn-primary ms-1",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isShowGeneralFeedback = !_ctx.isShowGeneralFeedback), ["prevent"]))
                }, _hoisted_14)
              ]),
              (_ctx.isShowGeneralFeedback)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_PimFeedbackPanelOld, {
                      "is-general-remark": true,
                      onSubmitPimFeedback: _ctx.submitPimFeedback,
                      onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                    }, null, 8, ["onSubmitPimFeedback", "onSubmitPimFeedbackCancel"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.productInfo != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.cnkCode), 1)
                                  ]),
                                  (_ctx.productInfo?.details?.commercial_name !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _hoisted_23,
                                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.productInfo?.details?.commercial_name), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.trademark !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _hoisted_26,
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.productInfo?.details?.trademark?.description), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.target_group !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _hoisted_29,
                                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.productInfo?.details?.target_group?.description), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.unit !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.productInfo?.details?.unit?.description), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.shape !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.productInfo?.details?.shape), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.width !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _hoisted_38,
                                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.productInfo?.details?.width), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.height !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        _hoisted_41,
                                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.productInfo?.details?.height), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.height !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _hoisted_44,
                                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.productInfo?.details?.height), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.weight !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _hoisted_47,
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.productInfo?.details?.weight), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.productInfo?.details?.volume !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                        _hoisted_50,
                                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.productInfo?.details?.volume), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_52
                  ]))
                : _createCommentVNode("", true),
              (_ctx.productInfo != null && _ctx.productInfo?.named_text_fragments?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _hoisted_55
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.named_text_fragments, (fragment) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: fragment,
                                      class: "mb-3"
                                    }, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("div", _hoisted_57, _toDisplayString(fragment?.text_fragment?.fragment?.title), 1),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("button", {
                                            class: "btn btn-sm btn-icon btn-primary ms-1",
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleIsShowFeedbackForFragmentWithId(fragment?.id)), ["prevent"])
                                          }, _hoisted_61, 8, _hoisted_59)
                                        ])
                                      ]),
                                      (_ctx.isShowFeedbackForFragmentWithId === fragment?.id)
                                        ? (_openBlock(), _createBlock(_component_PimFeedbackPanelOld, {
                                            key: 0,
                                            "is-general-remark": false,
                                            "field-code": fragment.text_fragment.code,
                                            "text-fragment-id": fragment.id,
                                            onSubmitPimFeedback: _ctx.submitPimFeedback,
                                            onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                                          }, null, 8, ["field-code", "text-fragment-id", "onSubmitPimFeedback", "onSubmitPimFeedbackCancel"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        innerHTML: fragment?.text_fragment?.fragment?.content,
                                        class: "value"
                                      }, null, 8, _hoisted_62)
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.productInfo != null && _ctx.productInfo?.text_fragments?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _hoisted_65
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.text_fragments, (fragment) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: fragment,
                                      class: "mb-3"
                                    }, [
                                      _createElementVNode("div", _hoisted_66, _toDisplayString(fragment?.text_fragment?.title), 1),
                                      _createElementVNode("div", {
                                        innerHTML: fragment?.text_fragment?.content,
                                        class: "value"
                                      }, null, 8, _hoisted_67)
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}